import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import React from 'react';
import CustomerInvoice from 'components/Invoice/CustomerInvoice';
import { useInvoiceData } from 'utils/queries/invoiceQueries';

export default function InvoiceModal({
  toggleModalOpen,
  modalOpen,
  chargersDetails = [],
  startDate = '',
  endDate = '',
  chargers = [],
}) {
  const { data: invoiceData } = useInvoiceData({
    chargers,
    startDate,
    endDate,
  });
  return (
    <Modal
      isOpen={modalOpen}
      toggle={toggleModalOpen}
      style={{ maxWidth: 1300 }}
    >
      <ModalHeader toggle={toggleModalOpen}></ModalHeader>
      <ModalBody style={{ marginTop: '-30px' }}>
        <CustomerInvoice
          invoiceData={invoiceData}
          startDate={startDate}
          endDate={endDate}
          chargersDetails={chargersDetails}
        />
      </ModalBody>
    </Modal>
  );
}
